export default "__VITE_ASSET__UbMU$YMJ__"